document.addEventListener("DOMContentLoaded", () => {
  const videoWrappers = document.querySelectorAll(".video-card-wrapper");

  videoWrappers.forEach(wrapper => {
    // --- (All this is the same) ---
    const card = wrapper.querySelector(".video-card");
    const modal = wrapper.querySelector(".video-modal");
    const overlay = wrapper.querySelector(".video-modal-overlay");
    const closeBtn = wrapper.querySelector(".video-modal-close");
    const iframe = wrapper.querySelector("iframe");

    if (!card || !modal || !overlay || !closeBtn || !iframe) return;

    const autoplaySrc = iframe.getAttribute("data-src");
    const baseSrc = iframe.getAttribute("src");

    // --- ⬇️ HERE IS THE FIX ⬇️ ---

    let player;
    let isVimeo = false;

    // 1. Check if it's a Vimeo video
    if (baseSrc && baseSrc.includes("vimeo.com")) {
      isVimeo = true;
      // 2. Only create a Vimeo player if it's a Vimeo video
      // This prevents the error on YouTube videos
      try {
        player = new Vimeo.Player(iframe);
      } catch (e) {
        console.error("Vimeo player init failed for:", baseSrc, e);
        isVimeo = false; // Treat as non-Vimeo if it fails
      }
    }

    const openModal = () => {
      modal.classList.remove("hidden");
      modal.classList.add("flex");
      iframe.setAttribute("src", autoplaySrc);
    };

    const closeModal = () => {
      modal.classList.add("hidden");
      modal.classList.remove("flex");

      // 3. Only call the Vimeo .pause() method if it's a Vimeo video
      if (isVimeo && player) {
        player.pause();
      }

      // 4. This part works to stop *both* Vimeo and YouTube videos
      iframe.setAttribute("src", baseSrc);
    };

    // --- (Event listeners are the same) ---
    card.addEventListener("click", openModal);
    closeBtn.addEventListener("click", closeModal);
    overlay.addEventListener("click", closeModal);
  });

  // --- (Escape key listener is the same) ---
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      const openModal = document.querySelector(".video-modal.flex");
      if (openModal) {
        const closeBtn = openModal.querySelector(".video-modal-close");
        if (closeBtn) {
          closeBtn.click();
        }
      }
    }
  });
});